import { NavLink } from "react-router-dom";

import editIcon from "../assets/images/edit_ico.svg";
import viewIcon from "../assets/images/view_icon.svg";
export default function ActionButton({
  edit = false,
  view = false,
  id,
  actionTo,
}) {
  return (
    <>
      {edit ? (
        <NavLink to={`/${actionTo}/edit/${id}`}>
          <img src={editIcon} alt="edit/" />
        </NavLink>
      ) : (
        ""
      )}{" "}
      {/* &nbsp;&nbsp;
      {view ? (
        <NavLink to={`/${actionTo}/view/${id}`}>
          <img src={viewIcon} alt="edit/" />
        </NavLink>
      ) : (
        ""
      )} */}
    </>
  );
}
